var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from 'react';
import Button from '../Button/Button';
import Pagination from '../Pagination/Pagination';
import ToogleBtn from '../ToggleBtn/ToggleBtn';
import Tooltip from '../Tooltip/Tooltip';
import { Placements } from '../Tooltip/TooltipPlacementType';
import { useHelpers } from '../_hooks';
import { OperatorType } from '../_types';
import './Table.css';
import TableColumnsDropDown from './TableColumnsDropDown';
import TableGrid from './TableGrid';
import TableOptionsDropDown from './TableOptionsDropDown';
var Table = function (props) {
    var fields = props.fields, allItems = props.allItems, defaultSort = props.defaultSort, actions = props.actions, _a = props.rowsPerPage, rowsPerPage = _a === void 0 ? 100 : _a, _b = props.hideGoToEndButtons, hideGoToEndButtons = _b === void 0 ? false : _b, _c = props.showActionIcons, showActionIcons = _c === void 0 ? false : _c, _d = props.showFilter, showFilter = _d === void 0 ? false : _d, _e = props.showOptionsButton, showOptionsButton = _e === void 0 ? true : _e, _f = props.showFilterButton, showFilterButton = _f === void 0 ? true : _f, _g = props.showColumnsButton, showColumnsButton = _g === void 0 ? true : _g, _h = props.selectMode, selectMode = _h === void 0 ? false : _h, _j = props.responsive, responsive = _j === void 0 ? false : _j, _k = props.small, small = _k === void 0 ? false : _k, _l = props.bordered, bordered = _l === void 0 ? false : _l, _m = props.striped, striped = _m === void 0 ? false : _m, buttonsSlot = props.buttonsSlot, onFocusRowChange = props.onFocusRowChange, onSelectedRowChange = props.onSelectedRowChange, onDetailsToggle = props.onDetailsToggle, onFilter = props.onFilter, onSort = props.onSort, className = props.className;
    var sorter = useHelpers().sorter;
    var _o = useState([]), items = _o[0], setItems = _o[1];
    var _p = useState([]), hiddenColumns = _p[0], setHiddenColumns = _p[1];
    var _q = useState(small), isSmall = _q[0], setIsSmall = _q[1];
    var _r = useState(showFilter), isFilterVisible = _r[0], setIsFilterVisible = _r[1];
    var _s = useState([]), filters = _s[0], setFilters = _s[1];
    var _t = useState((defaultSort === null || defaultSort === void 0 ? void 0 : defaultSort.length) ? defaultSort : []), sortColumns = _t[0], setSortColumns = _t[1];
    var _u = useState(1), currentPage = _u[0], setCurrentPage = _u[1];
    var _v = useState([]), flatFields = _v[0], setFlatFields = _v[1];
    useEffect(function () {
        setItems((allItems === null || allItems === void 0 ? void 0 : allItems.length) ? allItems : []);
        if (!onFilter) {
            setSortFilter();
            sortIfDefault();
        }
    }, [allItems]);
    useEffect(function () {
        setIsSmall(small);
    }, [small]);
    useEffect(function () {
        setIsFilterVisible(showFilter);
    }, [showFilter]);
    useEffect(function () {
        setSortColumns((defaultSort === null || defaultSort === void 0 ? void 0 : defaultSort.length) ? defaultSort : []);
    }, [defaultSort]);
    useEffect(function () {
        var visibleFields = getVisibleFields(fields, hiddenColumns);
        var flatFields = getFlatFields(visibleFields);
        setFlatFields(flatFields);
    }, [fields, hiddenColumns]);
    var getVisibleFields = function (fields, hiddenColumns) {
        var vf = fields;
        if (hiddenColumns === null || hiddenColumns === void 0 ? void 0 : hiddenColumns.length)
            vf = fields.filter(function (f) {
                return (f === null || f === void 0 ? void 0 : f.name) && hiddenColumns.indexOf(f.name) === -1;
            });
        return vf;
    };
    var getFlatFields = function (fields) {
        return fields.reduce(function (a, f) { return a === null || a === void 0 ? void 0 : a.concat(f.subfields ? f.subfields : [f]); }, []);
    };
    var columns = function () {
        return fields.map(function (f) {
            if (f === null || f === void 0 ? void 0 : f.name)
                f.visible = hiddenColumns.indexOf(f.name) === -1;
            return f;
        });
    };
    var getTableItems = function (items) {
        if (items === void 0) { items = []; }
        if (onFilter || onSort)
            return allItems;
        if (currentPage) {
            var start = currentPage === 1 ? 0 : (currentPage - 1) * rowsPerPage;
            var visibleItems = items.slice(start, start + rowsPerPage);
            return visibleItems;
        }
        return items;
    };
    var handlePageChanged = function (page) { return setCurrentPage(page); };
    var handleVisibleColumnChange = function (column) {
        var newHiddenColumns = column.visible
            ? hiddenColumns.filter(function (c) { return c !== column.name; })
            : __spreadArray(__spreadArray([], hiddenColumns, true), [column.name], false);
        setHiddenColumns(newHiddenColumns);
    };
    var handleFetchItems = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var filter, sort, page, newFilters, currentItems;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    filter = payload.filter, sort = payload.sort, page = payload.page;
                    return [4, getNewFilters(filter)];
                case 1:
                    newFilters = _a.sent();
                    return [4, setConfigurations({ newFilters: newFilters, sort: sort, page: page })];
                case 2:
                    _a.sent();
                    return [4, getFilteredItems(allItems, newFilters)];
                case 3:
                    currentItems = _a.sent();
                    return [4, getSortItems(currentItems, sort)];
                case 4:
                    currentItems = _a.sent();
                    return [4, setItems(currentItems)];
                case 5:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    var getFilteredItems = function (items, filters) {
        if (items == null ||
            items.length === 0 ||
            filters == null ||
            filters.length === 0 ||
            onFilter ||
            onSort)
            return items;
        var filteredItems = __spreadArray([], items, true);
        var _loop_1 = function (i) {
            var currentFilter = filters[i];
            if (currentFilter.operator == null)
                filteredItems = filteredItems.filter(function (i) {
                    return String(i[currentFilter.field])
                        .toLowerCase()
                        .includes(currentFilter.value.toLowerCase());
                });
            else if (currentFilter.operator === OperatorType.GreaterOrEqual)
                filteredItems = filteredItems.filter(function (i) { return i[currentFilter.field] >= currentFilter.value; });
            else if (currentFilter.operator === OperatorType.LessOrEqual)
                filteredItems = filteredItems.filter(function (i) { return i[currentFilter.field] <= currentFilter.value; });
            else if (currentFilter.operator === OperatorType.Equal) {
                if (Array.isArray(currentFilter.value)) {
                    filteredItems = filteredItems.filter(function (i) {
                        return currentFilter.value.includes(i[currentFilter.field]);
                    });
                }
                else
                    filteredItems = filteredItems.filter(function (i) {
                        return String(i[currentFilter.field]).toLowerCase() ===
                            currentFilter.value.toLowerCase();
                    });
            }
            else if (currentFilter.operator === OperatorType.NotSet) {
                filteredItems = filteredItems.filter(function (i) {
                    var _a, _b;
                    var itemValue = (_a = String(i[currentFilter.field])) === null || _a === void 0 ? void 0 : _a.toLowerCase();
                    var filterValue = (_b = currentFilter === null || currentFilter === void 0 ? void 0 : currentFilter.value) === null || _b === void 0 ? void 0 : _b.toLowerCase();
                    return itemValue && filterValue
                        ? itemValue === null || itemValue === void 0 ? void 0 : itemValue.includes(filterValue)
                        : true;
                });
            }
        };
        for (var i = 0; i < filters.length; i++) {
            _loop_1(i);
        }
        return filteredItems;
    };
    var getSortItems = function (items, sort) {
        if (!sort || onSort || onFilter)
            return items;
        var sortItems = __spreadArray([], items, true);
        if (sort.direction === 'asc')
            sortItems.sort(function (a, b) {
                return sorter(a[sort.name], b[sort.name], true);
            });
        else if (sort.direction === 'desc')
            sortItems.sort(function (a, b) {
                return sorter(a[sort.name], b[sort.name], false);
            });
        else
            sortItems.sort(function (a, b) { return sorter(a.id, b.id, true); });
        return sortItems;
    };
    var sortIfDefault = function () {
        if ((allItems === null || allItems === void 0 ? void 0 : allItems.length) && (defaultSort === null || defaultSort === void 0 ? void 0 : defaultSort.length))
            setItems(getSortItems((allItems === null || allItems === void 0 ? void 0 : allItems.length) ? allItems : [], defaultSort[0]));
    };
    var setConfigurations = function (_a) {
        var newFilters = _a.newFilters, sort = _a.sort, page = _a.page;
        return __awaiter(void 0, void 0, void 0, function () {
            var newSortColumns;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!newFilters) return [3, 3];
                        return [4, setCurrentPage(1)];
                    case 1:
                        _b.sent();
                        return [4, setFilters(newFilters)];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        if (!sort) return [3, 5];
                        newSortColumns = sort.direction ? [sort] : [];
                        return [4, setSortColumns(newSortColumns)];
                    case 4:
                        _b.sent();
                        _b.label = 5;
                    case 5:
                        if (!page) return [3, 7];
                        return [4, setCurrentPage(page)];
                    case 6:
                        _b.sent();
                        _b.label = 7;
                    case 7: return [2];
                }
            });
        });
    };
    var getNewFilters = function (newFilter) {
        var newFilters = [];
        if (!newFilter)
            return filters;
        var field = flatFields.find(function (f) { return f.name === newFilter.field; });
        if (field.multifilter) {
            var filterIndex = filters.findIndex(function (f) { return f.field === newFilter.field; });
            if (filterIndex < 0) {
                newFilters = __spreadArray(__spreadArray([], filters, true), [newFilter], false);
            }
            else {
                var filter = filters[filterIndex];
                var filterValueIndex = filter.value.findIndex(function (value) { var _a; return value === ((_a = newFilter === null || newFilter === void 0 ? void 0 : newFilter.value) === null || _a === void 0 ? void 0 : _a[0]); });
                newFilters = filters.filter(function (f) { return f.field !== newFilter.field; });
                if (filterValueIndex >= 0) {
                    if (filter.value.length > 1) {
                        filter.value.splice(filterValueIndex, 1);
                        newFilters.push(filter);
                    }
                }
                else {
                    filter.value.push(newFilter.value[0]);
                    newFilters.push(filter);
                }
            }
        }
        else {
            newFilters = filters === null || filters === void 0 ? void 0 : filters.filter(function (f) {
                return f.field !== newFilter.field ||
                    (f.field === newFilter.field &&
                        f.operator !== newFilter.operator);
            });
            if (newFilter && (newFilter.value || (newFilter === null || newFilter === void 0 ? void 0 : newFilter.value) === false))
                newFilters = __spreadArray(__spreadArray([], newFilters, true), [newFilter], false);
        }
        return newFilters;
    };
    var clearAllFilters = function () {
        setFilters([]);
        var sortedItems = getSortItems((allItems === null || allItems === void 0 ? void 0 : allItems.length) ? allItems : [], sortColumns !== null && (sortColumns === null || sortColumns === void 0 ? void 0 : sortColumns.length) > 0
            ? sortColumns[0]
            : {});
        setItems(sortedItems);
    };
    var setSortFilter = function () {
        setFilters([]);
        if (sortColumns.length === 0)
            setSortColumns([]);
        setCurrentPage(1);
    };
    var getNumberOfPages = function () {
        var totalItems = items != null ? items.length : 0;
        if (totalItems == null ||
            totalItems <= 0 ||
            rowsPerPage == null ||
            rowsPerPage <= 0)
            return 1;
        return Math.ceil(totalItems / rowsPerPage);
    };
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "d-flex justify-content-between" },
            React.createElement("div", null,
                buttonsSlot,
                !!(filters === null || filters === void 0 ? void 0 : filters.length) &&
                    filters.find(function (f) {
                        return f.hasFocus == null || f.hasFocus === false;
                    }) && (React.createElement(Button, { variant: "flat", onClick: clearAllFilters }, "Clear all filters"))),
            React.createElement("div", { className: "table-options" },
                showOptionsButton && (React.createElement(Tooltip, { content: "Configure table", placement: Placements.Top },
                    React.createElement(TableOptionsDropDown, { isSmall: isSmall, onChange: function (value) { return setIsSmall(value); } }))),
                showFilterButton && (React.createElement(Tooltip, { content: isFilterVisible
                        ? 'Hide filters'
                        : 'Show filters', placement: Placements.Top },
                    React.createElement(ToogleBtn, { activateText: "", deactivateText: "", variant: "flat", iconClass: "fa-filter", toggleOn: isFilterVisible, onChange: function () {
                            return setIsFilterVisible(!isFilterVisible);
                        } }))),
                showColumnsButton && (React.createElement(Tooltip, { content: "Customize columns", placement: Placements.Top },
                    React.createElement(TableColumnsDropDown, { columns: columns(), onVisibleColumnChange: handleVisibleColumnChange }))))),
        React.createElement(TableGrid, { items: getTableItems(items), fields: flatFields, filters: filters, sortColumns: sortColumns, actions: actions, showActionIcons: showActionIcons, selectMode: selectMode, responsive: responsive, showFilter: isFilterVisible, small: isSmall, bordered: bordered, striped: striped, onFetchItems: handleFetchItems, onFocusRowChange: onFocusRowChange, onSelectedRowChange: onSelectedRowChange, onDetailsToggle: onDetailsToggle, onFilter: onFilter, onSort: onSort }),
        (items === null || items === void 0 ? void 0 : items.length) > rowsPerPage && !onSort && !onFilter && (React.createElement(Pagination, { outerClass: "justify-content-end", numberOfPages: getNumberOfPages(), selectedPage: currentPage, hideGoToEndButtons: hideGoToEndButtons, onPageChange: handlePageChanged }))));
};
export default Table;
